/** @format */

import {
  Box,
  Container,
  Paper,
  Typography,
  Skeleton,
  Stack,
  Grid,
} from '@mui/material';

import { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import MessageHistoryRecord from './message-history.record';
import { fetchMessageHistoryStart } from '../../redux/message-history/message-history.actions';
import {
  selectMessageHistories,
  selectIsMessageHistoryFetching,
} from '../../redux/message-history/message-history.selector';
import { selectSelectedFlightIds } from '../../redux/flightData/flightData.selector';

const MessageHistoryComponent = () => {
  const dispatch = useDispatch();
  const messageHistory = useSelector(selectMessageHistories);
  const isFetching = useSelector(selectIsMessageHistoryFetching);
  const flightIds = useSelector(selectSelectedFlightIds);

  useEffect(() => {
    dispatch(fetchMessageHistoryStart());
  }, [flightIds]);

  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          minWidth: '95vw',
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {isFetching ? (
              <Stack spacing={2}>
                <Skeleton variant="rectangular" height={118} />
                <Skeleton variant="rectangular" height={118} />
                <Skeleton variant="rectangular" height={118} />
              </Stack>
            ) : (
              Object.keys(messageHistory)?.map((flightId, i) => (
                <Grid item xs={2} sm={4} md={4} key={i}>
                  <MessageHistoryRecord
                    key={flightId}
                    flightId={flightId}
                    pilotsMessages={messageHistory[flightId].pilotsMessages}
                    voucherMessages={messageHistory[flightId].voucherMessages}
                  />
                </Grid>
              )) || null
            )}
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default MessageHistoryComponent;
